/**
 * LocalStorage-backed app settings (e.g. last section used for / redirect).
 */
const STORAGE_KEY = 'veilstream_app_settings'

export type AppSection = 'projects' | 'databases'

export interface AppSettings {
  lastSection: AppSection
}

const DEFAULT_SETTINGS: AppSettings = {
  lastSection: 'projects',
}

function readSettings(): AppSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_SETTINGS }
    const parsed = JSON.parse(raw) as Partial<AppSettings>
    return {
      lastSection: parsed.lastSection === 'databases' ? 'databases' : 'projects',
    }
  } catch {
    return { ...DEFAULT_SETTINGS }
  }
}

function writeSettings(settings: AppSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
  } catch {
    // ignore
  }
}

export function getAppSettings(): AppSettings {
  return readSettings()
}

export function setAppSettings(partial: Partial<AppSettings>): void {
  const current = readSettings()
  const next = { ...current, ...partial }
  writeSettings(next)
}

export function updateLastSection(section: AppSection): void {
  setAppSettings({ lastSection: section })
}
